import { render, staticRenderFns } from "./TicketCollector.vue?vue&type=template&id=d5964284&scoped=true&"
import script from "./TicketCollector.vue?vue&type=script&lang=js&"
export * from "./TicketCollector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5964284",
  null
  
)

export default component.exports